"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../helpers/api.js");
var _createAction = require("../../helpers/createAction.js");
var _constants = require("../../constants");
var Reports = /*#__PURE__*/_createClass(function Reports(api) {
  var _this = this;
  _classCallCheck(this, Reports);
  this.reportCreate = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId, "/usage_reports");
    },
    request: function request(getState, start, end, questionBankId) {
      return _this.api.post("".concat((0, _api.selectedOrganizationUrl)(getState()), "/usage_reports"), {
        start_time: start,
        end_time: end,
        question_bank_id: questionBankId
      });
    },
    loadingConstant: _constants.REPORT_CREATING,
    loadedConstant: _constants.REPORT_CREATED,
    errorConstant: _constants.REPORT_CREATE_ERROR
  });
  this.memberGroupReportCreate = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId, userId, classId, questionBankId) {
      return "organizations/".concat(organizationId, "/user/").concat(userId, "/class/").concat(classId, "/question_bank/").concat(questionBankId);
    },
    request: function request(getState, userId, classId, questionBankId, start, end) {
      return _this.api.post("".concat((0, _api.selectedOrganizationUrl)(getState()), "/usage_reports/user/").concat(userId, "/class/").concat(classId, "/question_bank/").concat(questionBankId), {
        start_time: start,
        end_time: end,
        question_bank_id: questionBankId
      });
    },
    loadingConstant: _constants.MEMBER_GROUP_REPORT_CREATING,
    loadedConstant: _constants.MEMBER_GROUP_REPORT_CREATED,
    errorConstant: _constants.MEMBER_GROUP_REPORT_CREATE_ERROR
  });
  this.reportsFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId) {
      return "organizations/".concat(organizationId, "/usage_reports");
    },
    request: function request(getState) {
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/usage_reports"));
    },
    loadingConstant: _constants.REPORTS_FETCHING,
    loadedConstant: _constants.REPORTS_FETCHED,
    errorConstant: _constants.REPORTS_FETCHING_ERROR
  });
  this.reportFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(reportId) {
      return "/usage_reports/".concat(reportId);
    },
    request: function request(getState, reportId) {
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/usage_reports/").concat(reportId));
    },
    loadingConstant: _constants.REPORT_FETCHING,
    loadedConstant: _constants.REPORT_FETCHED,
    errorConstant: _constants.REPORT_FETCHING_ERROR
  });
  this.classReport = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId, reportId, questionBankId, classId) {
      return "organizations/".concat(organizationId, "/usage_reports/question_bank/").concat(questionBankId, "/").concat(reportId, "/class_report/").concat(classId);
    },
    request: function request(getState, reportId, questionBankId, classId) {
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/usage_reports/").concat(reportId, "/question_bank/").concat(questionBankId, "/class/").concat(classId));
    },
    loadingConstant: _constants.CLASS_REPORT_FETCHING,
    loadedConstant: _constants.CLASS_REPORT_FETCHED,
    errorConstant: _constants.CLASS_REPORT_ERROR
  });
  this.reportUsersFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(reportId, questionBankId) {
      return "organizations/report_users/".concat(reportId, "/question_bank/").concat(questionBankId);
    },
    request: function request(getState, reportId, questionBankId) {
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/report_users/").concat(reportId, "/question_bank/").concat(questionBankId));
    },
    loadingConstant: _constants.REPORT_USERS_FETCHING,
    loadedConstant: _constants.REPORT_USERS_FETCHED,
    errorConstant: _constants.REPORT_USERS_FETCH_ERROR
  });
  this.memberGroupReportsFetch = (0, _createAction.createApiRequestAction)({
    getKey: function getKey(organizationId, userId, classId) {
      return "organizations/".concat(organizationId, "/user/").concat(userId, "/class/").concat(classId);
    },
    request: function request(getState, organizationId, userId, classId) {
      return _this.api.get("".concat((0, _api.selectedOrganizationUrl)(getState()), "/usage_reports/user/").concat(userId, "/class/").concat(classId));
    },
    loadingConstant: _constants.MEMBER_GROUP_REPORTS_FETCHING,
    loadedConstant: _constants.MEMBER_GROUP_REPORTS_FETCHED,
    errorConstant: _constants.MEMBER_GROUP_REPORTS_FETCH_ERROR
  });
  this.api = api;
}

// class reports are tied to the main organization user reports member group reports are run on the classes themselves
);

var _default = exports.default = Reports;